import React from 'react';
import { Button, Space, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title } = Typography;

const PageHeader = ({ title, onBack, extra, style, ...rest }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 0',
        ...style,
      }}
      {...rest}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {onBack && (
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
            aria-label="Go back"
          />
        )}
        <Title level={4} style={{ margin: 0 }}>
          {title}
        </Title>
      </div>
      {extra && (
        <Space>
          {Array.isArray(extra) ? extra : [extra]}
        </Space>
      )}
    </div>
  );
};

export default PageHeader;
